import React from "react";
import { cover, size } from "polished";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
var logoPlaceHolderSvg = function logoPlaceHolderSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon",
    d: "M31.252 17.855c-2.977-2.981-6.622-1.798-9.6 1.185l-4.62 4.629c-2.127 2.13-2.898 4.813-.77 6.942 2.126 2.131 4.804 1.36 6.93-.771l4.621-4.63c1.276-1.278 1.634-2.991.357-4.27-1.276-1.278-2.932-.864-4.208.414l-3.079 3.086a1.09 1.09 0 1 0 1.54 1.542l3.08-3.085c.426-.426.702-.839 1.128-.413.425.426.068.759-.357 1.185l-4.62 4.63c-1.276 1.277-2.576 2.048-3.851.771-1.276-1.279-.506-2.58.77-3.858l4.622-4.628c2.126-2.13 4.39-3.315 6.518-1.186 2.126 2.131 1 4.456-1.127 6.585l-3.083 3.086a1.092 1.092 0 0 0 0 1.542 1.088 1.088 0 0 0 1.542 0l3.08-3.084c2.978-2.984 4.105-6.69 1.127-9.672z"
  }));
};
logoPlaceHolderSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48"
};
import { zIndex } from "../../../settings";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import getTextColor from "../../../utils/getTextColor";
import space from "../../../utils/space";
import TextAtm from "../../atoms/TextAtm";
import { cssTextAtm } from "../../atoms/TextAtm/TextAtm.styled";
import PushOrg from "../../organisms/PushOrg";
import Link from "../../quarks/Link";
import Picture from "../../quarks/Picture";
import TooltipMol from "../TooltipMol";
var paddingSpace = 2;
var logoSizeSpace = 6;
var backgroundColor = "backgroundLight";
var Container = styled.div.withConfig({
  componentId: "sc-9ag0jj-0"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["display:flex;position:relative;flex:1;align-self:stretch;padding:", ";border-radius:", ";background-color:", ";box-shadow:", ";"], space(paddingSpace), getBorderRadius(theme, "large"), getColor(theme, backgroundColor), getBoxShadow(theme, "small"));
});
var logoStyles = function logoStyles(theme) {
  return css(["", ";flex-shrink:0;margin-right:", ";overflow:hidden;border-radius:", ";"], size(space(logoSizeSpace)), space(paddingSpace), getBorderRadius(theme, "large"));
};
var Logo = styled(Picture).withConfig({
  componentId: "sc-9ag0jj-1"
})(function (_ref2) {
  var theme = _ref2.theme;
  return css(["", ";"], logoStyles(theme));
});
var logoPlaceholderBackgroundColor = "primaryLight";
var LogoPlaceholder = styled(logoPlaceHolderSvg).withConfig({
  componentId: "sc-9ag0jj-2"
})(function (_ref3) {
  var theme = _ref3.theme;
  return css(["", ";fill:", ";.icon{fill:", ";}"], logoStyles(theme), getColor(theme, logoPlaceholderBackgroundColor), getTextColor(theme, logoPlaceholderBackgroundColor));
});
var Title = styled(Link).withConfig({
  componentId: "sc-9ag0jj-3"
})(function (_ref4) {
  var theme = _ref4.theme;
  return css(["", ";text-decoration:none;&::before{", ";content:\"\";}&:hover{color:", ";}"], cssTextAtm({
    typography: "small3",
    onColor: backgroundColor,
    emphasis: "medium"
  }), cover(), getColor(theme, "primary"));
});
var ContentWrapper = styled.div.withConfig({
  componentId: "sc-9ag0jj-4"
})(["display:flex;flex-direction:column;justify-content:space-between;width:100%;"]);
var DetailsWrapper = styled.div.withConfig({
  componentId: "sc-9ag0jj-5"
})(["display:flex;align-items:flex-end;justify-content:space-between;"]);
var PriceWrapper = styled.div.withConfig({
  componentId: "sc-9ag0jj-6"
})(["display:flex;flex-wrap:wrap;align-items:baseline;justify-content:space-between;"]);
var StyledTooltip = styled(TooltipMol).withConfig({
  componentId: "sc-9ag0jj-7"
})(["position:relative;z-index:", ";margin-left:", ";"], zIndex.TooltipMolContent, space(1));
function ProductBundleMolItem(_ref5) {
  var img = _ref5.img,
    title = _ref5.title,
    price = _ref5.price,
    priceSuffix = _ref5.priceSuffix,
    to = _ref5.to,
    href = _ref5.href,
    hrefTitle = _ref5.hrefTitle,
    tooltip = _ref5.tooltip,
    onClick = _ref5.onClick;
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: backgroundColor
  }, img ? /*#__PURE__*/React.createElement(Logo, {
    srcData: img.src,
    alt: img.alt || title
  }) : /*#__PURE__*/React.createElement(LogoPlaceholder, null), /*#__PURE__*/React.createElement(ContentWrapper, null, /*#__PURE__*/React.createElement(PushOrg, {
    bottomSpace: 1
  }, /*#__PURE__*/React.createElement(Title, {
    to: to,
    href: href,
    title: hrefTitle,
    onClick: onClick
  }, title)), /*#__PURE__*/React.createElement(DetailsWrapper, null, /*#__PURE__*/React.createElement(PriceWrapper, null, /*#__PURE__*/React.createElement(PushOrg, {
    rightSpace: 1
  }, /*#__PURE__*/React.createElement(TextAtm, {
    typography: "small3"
  }, price)), /*#__PURE__*/React.createElement(TextAtm, {
    typography: "tiny1",
    emphasis: "medium"
  }, priceSuffix)), tooltip ? /*#__PURE__*/React.createElement(StyledTooltip, null, tooltip) : null))));
}
export default ProductBundleMolItem;